<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M10.2294 17.9999L16.7495 11.4999L10.2294 4.99988L8.99995 6.22553L14.2906 11.4999L8.99995 16.7742L10.2294 17.9999Z" />
</svg>